import Action from '../../Action'
import './styles/ImportInfo.css'
import { useState ,useEffect,useRef } from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import { importFunction } from '../../../utils/utils';
const ImportInfo =({handleShowPopup,server,languaje,mode,importLoading,closeImportModal,setImportLoading})=>{
    const [file, setFile] = useState(null);
    const [disabled,setDisabled]=useState(true)
    const [msgError,setMsgError]=useState(true)
    const [boolError,setBoolError]=useState(false)
    const [response,setResponse]=useState([])
    const fileInputRef = useRef(null);

    const handleFileClick = () => {
      fileInputRef.current.click(); // Simula el clic en el input file oculto
    };
    // // Función para manejar la selección de archivo
    // const handleFileChange = (e) => {
    //   setFile(e.target.files[0]);
    // };

    // Función para manejar la importación
    const handleImport = async () => {
        setResponse([])
      if (!file) {
        alert('Por favor selecciona un archivo');
        return;
      }
  
      const formData = new FormData();
      formData.append('file_import', file); // Agregamos el archivo seleccionado al FormData
  
      setImportLoading(true);
  
      try {
          const response = await fetch(server.url + '/api/v1/cassia/brands/import', {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
            body: formData, // Enviamos el FormData con el archivo
          });
          if (response.ok) {
              const data1 = await response.json();
              setResponse(data1.data)
              const keys = Object.keys(data1.data[0]);

              // Obtener los valores de todos los objetos
              const values = data1.data.map(obj => Object.values(obj));

              // Unir las claves con los valores
              const result = [keys, ...values];
              handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['importCorr'])),capitalizeFirstLetter((lang[languaje]['msgImpor'])), true)
              setFileContent(result);
              setTableData(result);
              setDisabled(true)
              setImportLoading(false);
              setBoolError(false);
          } else {
            setImportLoading(false);
            setBoolError(true);
            handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            setMsgError('Error en la importación');
            throw new Error('Error en la importación');
          }
      } catch (error) {
  setImportLoading(false);
  setBoolError(true);
  setMsgError('Error al importar archivo');
  handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
  console.error('Error al importar archivo:', error);
}
    };
    const [fileContent, setFileContent] = useState(null);
    const [tableData, setTableData] = useState([]);
    useEffect(()=>{
        if(tableData.length!=0 && response.length==0){
            setDisabled(false)
        }else{
            setDisabled(true)
        }
    },[tableData])
    // Función para leer el archivo
    const handleFileChange = (e) => {
      setResponse([])
      const file = e.target.files[0];
      setFile(file)
      importFunction(file,setFileContent,setTableData)
    };

    // Renderizar la tabla
    const renderTable = () => { 
      if (!tableData.length) return null;

      return (
          <div className="cont-table-portafolio border-table">
              <div className={"head-table-portafolio"+mode}>
              <div className="compact-head-table-portafolio">
              {tableData[0].map((header, index) => (
            //           <th key={index}>{header}</th
            (<div className="field-head-table-mantenimiento field-larger"  key={index} style={{width:'25%'}}>  {header} </div>)
                    ))}
                </div>
              </div>
              <div className="body-table-portafolio" style={{overflowY:'auto'}}>
              {tableData.slice(1).map((row, rowIndex) => (
                 <div
                 className={"row-table-portafolio"+mode}
                 key={rowIndex}
                 style={{height:'40px'}}
               >
                  {row.map((cell, cellIndex) => (
                    (row.length>4)?
                    
           <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)',color:((row[4]!="")?'red':'var(--green)')}} key={cellIndex}>
           {cell}
         </div>:
         <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
        {cell}
        </div>
                      ))}
                 
               </div>
            
                  ))}
              </div>
          </div>
      );
    };
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {lang[languaje]['importar'].toUpperCase()+' '+lang[languaje]['datos'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' >
                
                    <div className="cont-import-GS-box"> 
                        <div className='row-cont-input-file'>
                            {
                                (importLoading)?<div className='txtCantData'>
                                {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])+'...'}
                        </div>:
                                <div className="file-input-container">
                                <input 
                                accept=".json,.csv,.xlsx"
                                    type="file" 
                                    ref={fileInputRef} 
                                    style={{ display: 'none' }} 
                                    onChange={ handleFileChange}
                                />
                                <button className="custom-file-button" onClick={handleFileClick}>
                                   {capitalizeFirstLetter(lang[languaje]['selectFile'])}
                                </button>
      
                                <span id="file-name">
                                    {(fileInputRef.current?.files[0]==undefined)?capitalizeFirstLetter(lang[languaje]['sinArchivo']):(fileInputRef.current?.files[0].name || capitalizeFirstLetter(lang[languaje]['sinArchivo']))}
                                </span>
                            </div>
                            }
                        </div>
                        <div className='row-cont-input-table'>
                        
      
      
        {fileContent ? renderTable() : <div className="cont-table-portafolio border-table msgImport"><p>{capitalizeFirstLetter(lang[languaje]['sinArchivo'])}.</p></div>}
      
                        <div className='txtCantData'>
                                {((boolError)?<div style={{color:'red'}}>{msgError}</div>:
                                    (tableData.length==0)?'':
                                        ((response.length==0)?
                                            capitalizeFirstLetter(lang[languaje]['registrosCargar'])+': '+(tableData.length-1):
                                                <>
                                                    <div style={{color:'var(--green)'}}>{capitalizeFirstLetter(lang[languaje]['registrosCorrectos'])+':'+response.filter(item => item.detail === "").length}</div> &nbsp;&nbsp;&nbsp;
                                                    <div style={{color:'red'}}>{capitalizeFirstLetter(lang[languaje]['registrosIncorrectos'])+':'+response.filter(item => item.detail !== "").length}</div>
                                                </>
                                                ))}
                        </div>
                        </div>
                        <div className='row-cont-input-buttons'>
                        {(importLoading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%',width:'100%'}}><LoadSimple></LoadSimple></div>:
                        (
                        <>
                        <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(((response.length==0)?lang[languaje]['cancelar']:lang[languaje]['cerrar']))}  action={closeImportModal}/>
                        <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['importar'])}  action={handleImport}/>
                        </>
                        )
                        }
                        </div>           
                    </div>
                </div>
                </div>
        </div>
    )
}

export default ImportInfo